import React, { createContext, useEffect, useState } from 'react';

export const SelectedCountryContext = createContext({
  selectedCountryId: '',
  setSelectedCountryId: () => {}
});

export const SelectedCountryProvider = ({ children }) => {
  const [selectedCountryId, setSelectedCountryId] = useState(() => {
    try {
      return localStorage.getItem('selectedCountryId') || '';
    } catch (_) { return ''; }
  });

  // Persist any change centrally
  useEffect(() => {
    try {
      if (selectedCountryId) {
        localStorage.setItem('selectedCountryId', String(selectedCountryId));
      }
    } catch (_) {}
  }, [selectedCountryId]);

  return (
    <SelectedCountryContext.Provider value={{ selectedCountryId, setSelectedCountryId }}>
      {children}
    </SelectedCountryContext.Provider>
  );
};
